import React, { useEffect, useState } from 'react';
import { useForm } from '@mantine/form';
import { TextInput, Button, Group, Title, Checkbox, Select, Text, Textarea, Slider, Stack, TransferList, Divider, MultiSelect } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconCheck } from '@tabler/icons-react';
import { getPartners, getCategories, getBranchesFromPartner, saveBenefit, updateBenefit, getDiscountTypes, getBenefitTypes, getProvinces } from '../../services/api.service';
import { DateTimePicker } from '@mantine/dates';

const BenefitForm = ({ closeModal, isEdit, benefit }) => {

	// Hooks
	const [isLoading, toggleLoading] = useState(false);
	const [partners, setPartners] = useState([]);
	const [categories, setCategories] = useState([]);
	const [discountTypes, setDiscountTypes] = useState([]);
	const [benefitTypes, setBenefitTypes] = useState([]);
	const [branches, setBranches] = useState([[], []]);
	const [provinces, setProvinces] = useState([]);
	const form = useForm({
		initialValues: {
			name: '',
			partner: {
				id: 0,
			},
			category: {
				id: 0,
			},
			description: '',
			discountType: {
				id: 0,
			},
			startDate: null,
			endDate: null,
			active: true,
			code: '',
			hasStock: true,
			benefitType: {
				id: 0,
			},
			legals: '',
			maxDaysCoupon: 30,
			branch: [],
			province: [],
		},
	});

	// Check if edit
	useEffect(() => {
		if (isEdit) form.setValues({
			name: benefit.name,
			partner: {
				id: benefit.partner.id,
			},
			category: {
				id: benefit.category.id,
			},
			description: benefit.description,
			discountType: {
				id: benefit.discountType.id,
			},
			startDate: new Date(benefit.startDate),
			endDate: new Date(benefit.endDate),
			active: benefit.active,
			code: benefit.code,
			hasStock: benefit.hasStock,
			benefitType: {
				id: benefit.benefitType.id,
			},
			legals: benefit.legals,
			maxDaysCoupon: benefit.maxDaysCoupon,
			branch: [],
			province: benefit.province?.map(p => (p.id)) || [],
		});
		// eslint-disable-next-line
	}, []);

	// On load
	useEffect(() => {

		// Get partners
		getPartners(function (response) {

			// Loop partners
			var partners = [];
			for (var i = 0; i < response.data.length; i++) {

				// Assign
				partners.push({
					label: response.data[i].name,
					value: response.data[i].id,
				});

			}

			// Set state
			setPartners(partners);

		}, function (error) {

			// Show error
			notifications.show({
				title: 'Error',
				message: error,
				color: 'red'
			});

		});

		// Get provinces
		getProvinces(function (response) {
			// Loop provinces
			var provinces = [];
			for (var i = 0; i < response.data.length; i++) {

				// Assign
				provinces.push({
					label: response.data[i].name,
					value: response.data[i].id,
				});
			}
			// Set state
			setProvinces(provinces);
		}, function (error) {
			// Show error
			notifications.show({
				title: 'Error',
				message: error,
				color: 'red'
			});
		});

		// Get categories
		getCategories(function (response) {

			// Loop categories
			var categories = [];
			for (var i = 0; i < response.data.length; i++) {

				// Assign
				categories.push({
					label: response.data[i].name,
					value: response.data[i].id,
				});

			}

			// Set state
			setCategories(categories);

		}, function (error) {

			// Show error
			notifications.show({
				title: 'Error',
				message: error,
				color: 'red'
			});

		});

		// Get discount types
		getDiscountTypes(function (response) {

			// Loop discount types
			var discountTypes = [];
			for (var i = 0; i < response.data.length; i++) {

				// Assign
				discountTypes.push({
					label: response.data[i].name,
					value: response.data[i].id,
				});

			}

			// Set state
			setDiscountTypes(discountTypes);

		}, function (error) {

			// Show error
			notifications.show({
				title: 'Error',
				message: error,
				color: 'red'
			});

		});

		// Get benefit types
		getBenefitTypes(function (response) {

			// Loop benefit types
			var benefitTypes = [];
			for (var i = 0; i < response.data.length; i++) {

				// Assign
				benefitTypes.push({
					label: response.data[i].name,
					value: response.data[i].id,
				});

			}

			// Set state
			setBenefitTypes(benefitTypes);

		}, function (error) {

			// Show error
			notifications.show({
				title: 'Error',
				message: error,
				color: 'red'
			});

		});

	}, []);

	// On partner change
	useEffect(() => {

		// If partner changed
		if (form.values.partner.id) {

			// Get branches
			getBranchesFromPartner(form.values.partner.id, function (response) {

				// Loop branches
				var branches = [];
				for (var i = 0; i < response.data.length; i++) {

					// Assign
					branches.push({
						value: response.data[i].id.toString(),
						label: response.data[i].name,
					});

				}

				// Set state
				setBranches([branches, []]);

			}, function (error) {

				// Show error
				notifications.show({
					title: 'Error',
					message: error?.message?.[0] || 'Error inesperado.',
					color: 'red'
				});

			});

		}

	}, [form.values.partner.id]);

	// Submit form
	const onSubmit = async () => {

		// Set loader
		toggleLoading(true);

		// Loop selected branches
		var branchesArray = [];
		for (var i = 0; i < branches[1].length; i++) {

			// Set in required format
			branchesArray.push({
				id: parseInt(branches[1][i].value),
				name: branches[1][i].label,
			});

		}

		// Assign to form
		form.setValues({
			branch: branchesArray
		});


		// Get and set from state
		var formValues = form.values;
		formValues.branch = branchesArray;

		// Transform province values to expected format
		formValues.province = formValues.province?.map((id) => ({ id: Number(id) })) || [];

		// Submit to API
		submitBenefit(formValues);

	}

	// Send benefit to API
	const submitBenefit = (values) => {

		// Conditions
		if (!isEdit) {

			// Call API
			saveBenefit(values, function () {

				// Show success
				notifications.show({
					title: 'Beneficio creado correctamente',
					color: 'green',
					icon: <IconCheck />
				});

				// Close after 1 second
				setTimeout(() => {

					// Close modal
					closeModal();

				}, 1000);

			}, function (error) {

				// Remove preloader
				toggleLoading(false);

				// Show error
				notifications.show({
					title: 'Error',
					message: error?.message?.[0] || 'Error inesperado.',
					color: 'red'
				});

			});

		} else {

			// Call API
			updateBenefit(benefit.id, values, function () {

				// Show success
				notifications.show({
					title: 'Beneficio modificado correctamente',
					color: 'green',
					icon: <IconCheck />
				});

				// Close after 1 second
				setTimeout(() => {

					// Close modal
					closeModal();

				}, 1000);

			}, function (error) {

				// Remove preloader
				toggleLoading(false);

				// Show error
				notifications.show({
					title: 'Error',
					message: error?.message?.[0] || 'Error inesperado.',
					color: 'red'
				});

			});

		}

	}

	return (
		<>
			{/* Form */}
			<form onSubmit={form.onSubmit(onSubmit)}>
				{/* Title */}
				<Title
					order={5}
					mb="md"
				>
					{isEdit ? 'Modificar' : ''} Información del Beneficio
				</Title>
				<Divider
					mb="xs"
					label="Status"
				/>
				{/* Input Group */}
				<Group grow>
					{/* Active */}
					<Checkbox
						label="Activo"
						checked={form.values.active}
						onChange={(event) => form.setFieldValue('active', event.currentTarget.value)}
						{...form.getInputProps('active')}
					/>
					{/* Stock */}
					<Checkbox
						label="Con Inventario"
						checked={form.values.hasStock}
						onChange={(event) => form.setFieldValue('hasStock', event.currentTarget.value)}
						{...form.getInputProps('hasStock')}
					/>
				</Group>
				<Divider
					mt="lg"
					mb="xs"
					label="Información General"
				/>
				{/* Input Group */}
				<Group grow>
					{/* Name */}
					<TextInput
						required
						label="Nombre"
						placeholder="Nombre del beneficio"
						value={form.values.name}
						onChange={(event) => form.setFieldValue('name', event.currentTarget.value)}
						{...form.getInputProps('name')}
					/>
					{/* Code */}
					<TextInput
						required
						label="Código"
						placeholder="Código del beneficio"
						value={form.values.code}
						onChange={(event) => form.setFieldValue('code', event.currentTarget.value)}
						{...form.getInputProps('code')}
					/>
				</Group>
				{/* Input Group */}
				<Group
					grow
					mt="md"
				>
					{/* Start Date */}
					<DateTimePicker
						required
						label="Fecha de Inicio"
						placeholder="Elige una fecha"
						valueFormat="DD-MM-YYYY HH:mm"
						value={form.values.startDate}
						onChange={(event) => form.setFieldValue('startDate', event.currentTarget.value)}
						{...form.getInputProps('startDate')}
					/>
					{/* End Date */}
					<DateTimePicker
						clearable
						label="Fecha de Finalización"
						placeholder="Elige una fecha"
						valueFormat="DD-MM-YYYY HH:mm"
						value={form.values.endDate}
						minDate={form.values.startDate}
						onChange={(event) => form.setFieldValue('endDate', event.currentTarget.value)}
						{...form.getInputProps('endDate')}
					/>
					{/* Max Days */}
					<Stack>
						{/* Label */}
						<Text
							size="sm"
							color="#C1C2C5"
							fw={500}
						>
							Días Máximos de Cupón: {form.values.maxDaysCoupon} días
						</Text>
						{/* Days */}
						<Slider
							marks={[
								{ value: 30 },
								{ value: 60 },
							]}
							value={form.values.maxDaysCoupon}
							onChange={(event) => form.setFieldValue('maxDaysCoupon', event.currentTarget.value)}
							{...form.getInputProps('maxDaysCoupon')}
							min={1}
							max={90}
							step={1}
							precision={1}
						/>
					</Stack>
				</Group>
				{/* Input Group */}
				<Group
					grow
					mt="md"
				>
					{/* Category ID */}
					<Select
						searchable
						withinPortal
						required
						label="Categoría"
						placeholder="Busca una categoría"
						value={form.values.category.id}
						onChange={(event) => form.setFieldValue('category.id', event.currentTarget.value)}
						{...form.getInputProps('category.id')}
						nothingFound="Sin resultados"
						data={categories}
					/>
					{/* Benefit Type ID */}
					<Select
						searchable
						withinPortal
						required
						label="Tipo de Descuento"
						placeholder="Busca un tipo de descuento"
						value={form.values.discountType.id}
						onChange={(event) => form.setFieldValue('discountType.id', event.currentTarget.value)}
						{...form.getInputProps('discountType.id')}
						nothingFound="Sin resultados"
						data={discountTypes}
					/>
					{/* Benefit Type ID */}
					<Select
						searchable
						withinPortal
						required
						label="Tipo de Beneficio"
						placeholder="Busca un tipo de beneficio"
						value={form.values.benefitType.id}
						onChange={(event) => form.setFieldValue('benefitType.id', event.currentTarget.value)}
						{...form.getInputProps('benefitType.id')}
						nothingFound="Sin resultados"
						data={benefitTypes}
					/>
				</Group>
				<Group
					grow
					mt="md"
				>
					<MultiSelect
						label="Provincias"
						placeholder="Provincia"
						data={provinces}
						{...form.getInputProps('province')}
					/>
				</Group>
				{/* Input Group */}
				<Group
					grow
					mt="md"
				>
					{/* Description */}
					<Textarea
						required
						label="Descripción"
						placeholder="Describe este beneficio"
						autosize
						minRows={2}
						maxRows={4}
						value={form.values.description}
						onChange={(event) => form.setFieldValue('description', event.currentTarget.value)}
						{...form.getInputProps('description')}
					/>
				</Group>
				{/* Input Group */}
				<Group
					grow
					mt="md"
				>
					{/* Legals */}
					<Textarea
						required
						label="Legales"
						placeholder="Restricciones de este beneficio"
						autosize
						minRows={2}
						maxRows={8}
						value={form.values.legals}
						onChange={(event) => form.setFieldValue('legals', event.currentTarget.value)}
						{...form.getInputProps('legals')}
					/>
				</Group>
				<Divider
					mt="lg"
					mb="xs"
					label="Partners y Sucursales"
				/>
				{/* Input Group */}
				<Group grow>
					{/* Partner ID */}
					<Select
						searchable
						withinPortal
						required
						label="Partner"
						placeholder="Busca un partner"
						value={form.values.partner.id}
						onChange={(event) => form.setFieldValue('partner.id', event.currentTarget.value)}
						{...form.getInputProps('partner.id')}
						nothingFound="Sin resultados"
						data={partners}
					/>
				</Group>
				{/* Input Group */}
				<Group
					grow
					mt="md"
				>
					{/* Branches */}
					<Stack spacing={2}>
						{/* Label */}
						<Text
							size="sm"
							color="#C1C2C5"
							fw={500}
						>
							Sucursales
						</Text>
						{/* List */}
						<TransferList
							value={branches}
							onChange={setBranches}
							searchPlaceholder="Buscar sucursal..."
							nothingFound="Sin resultados"
						/>
					</Stack>
				</Group>
				{/* Buttons */}
				<Group
					position="apart"
					grow={!isEdit}
				>
					{/* Cancel */}
					<Button
						mt="xl"
						color="red"
						onClick={closeModal}
						disabled={isLoading}
						variant="light"
						sx={{ flexGrow: isEdit ? 2 : 1 }}
					>
						Cancelar
					</Button>
					{/* Submit */}
					<Button
						mt="xl"
						type="submit"
						loading={isLoading}
						variant="filled"
						sx={{ flexGrow: isEdit ? 2 : 1 }}
					>
						{isEdit ? 'Guardar Cambios' : 'Crear Beneficio'}
					</Button>
				</Group>
			</form>
		</>
	);

}

export default BenefitForm;
